import Header from "../../layout/Header/Header";
import ScheduleContent from "./ScheduleContent/ScheduleContent";

const Schedule = () => {
  return (
    <main>
      <Header />

      <ScheduleContent />
    </main>
  );
};

export default Schedule;
